<template>
  <vs-popup title="Fiyat Güncelleme Logları" :active.sync="isActive" fullscreen>
    <b-row class="mb-1">
      <b-col cols="12">
        <strong>{{ stockName }}</strong>
      </b-col>
      <b-col cols="12" class="mt-1">
        <strong>Stok Kodu:</strong> {{ stockCode }} - <strong>Barkod:</strong> {{ stockBarcode }}
      </b-col>
    </b-row>
    <div id="loading-priceLogs" class="vs-con-loading__container">
      <ag-grid-vue style="width: 100%; height: 500px" class="ag-theme-alpine" :defaultColDef="defaultColDef"
        :columnDefs="columnDefs" :rowData="logList" :localeText="localeText" :masterDetail="true"
        :detailCellRendererParams="detailParams" :detailRowAutoHeight="true">
      </ag-grid-vue>
    </div>
    <div class="d-flex align-items-center mt-1">{{ logList ? logList.length : 0 }} adet pazaryeri kaydı</div>
  </vs-popup>
</template>

<script>
import state from "../../store/state";
import Store from "../../store/store";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";

export default {
  components: {
    AgGridVue
  },
  data() {
    return {
      isActive: false,
      logList: null,
      columnDefs: null,
      localeText: null,
      stockName: "",
      stockCode: "",
      stockBarcode: "",
      defaultColDef: {
        sortable: true,
        resizable: true
      },
      detailParams: {
        detailGridOptions: {
          columnDefs: [
            { field: "tarih", headerName: "Tarih", filter: "agSetColumnFilter", width: 190 },
            {
              field: "mesaj",
              headerName: "Mesaj",
              filter: "agSetColumnFilter",
              flex: 1,
              wrapText: true,
              autoHeight: true
            }
          ],
          defaultColDef: { sortable: true, resizable: true }
        },
        getDetailRowData: function (params) {
          let logs = params.data.alan7;
          params.successCallback(Array.isArray(logs) ? logs : []);
        }
      }
    };
  },
  created() {
    this.localeText = this.$store.state.uzum.AG_GRID_LOCALE_EN;
  },
  methods: {
    open(data) {
      this.stockName = data.StokAdi;
      this.stockCode = data.stokKodu;
      this.stockBarcode = data.Barkod;
      this.logList = null;
      this.columnDefs = null;
      this.isActive = true;
      this.getPriceLogs();
    },
    getPriceLogs() {
      var vm = this;
      var vs = this.$vs;
      let type = "radius";
      const soap = require("soap");
      const url = state.sistemAddress;

      const args = {
        token: Store.state.tokenId,
        StokKodu: vm.stockCode,
        Barkod: vm.stockBarcode
      };
      vs.loading({
        container: "#loading-priceLogs",
        type
      });
      soap.createClient(url, function (err, client) {
        client.pazaryeriurunfiyatloglistesi(args, function (err, result) {
          if (result.pazaryeriurunfiyatloglistesiResult == "-1") {
            Store.dispatch("logout");
          }
          try {
            vs.loading.close("#loading-priceLogs > .con-vs-loading");
            let parsed = JSON.parse(result.pazaryeriurunfiyatloglistesiResult);
            let list = parsed && Array.isArray(parsed.liste) ? parsed.liste : [];
            vm.columnDefs = [];
            if (list.length > 0) {
              Object.keys(list[0]).forEach((val) => {
                // alan7 satır altında collapse (master/detail) olarak gösterilecek,
                // sonLog ise nesne olduğu için kolon olarak gösterilmez
                if (val === "alan7" || val === "sonLog") return;
                let col = { field: val, filter: "agSetColumnFilter" };
                // ilk kolona aç/kapa okunu ekle
                if (vm.columnDefs.length === 0) {
                  col.cellRenderer = "agGroupCellRenderer";
                  col.pinned = "left";
                }
                vm.columnDefs.push(col);
              });
            }
            vm.logList = list;
          } catch (error) {
            vs.loading.close("#loading-priceLogs > .con-vs-loading");
            vs.notify({
              title: "Fiyat Güncelleme Logları",
              text: error,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center"
            });
          }
        });
      });
    }
  }
};
</script>
